import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-assestmentviewresult',
  templateUrl: './assestmentviewresult.component.html',
  styleUrls: ['./assestmentviewresult.component.scss']
})
export class AssestmentviewresultComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
